<template>
  <FullBodyAvatar :customer="profile" animated :paused="false" customizable @click="openPopupProfileCard(profile?.customerId, 'customer_settings')" />
</template>

<style>
.gmf-my-avatar-fullbody .gmf-fullbody-avatar {
  max-width: 1024px;
  max-height: 256px;
  margin-bottom: 25px;
}
.gmf-my-avatar-fullbody .gmf-fullbody-avatar-content {
  height: 110%;
}
.gmf-my-avatar-fullbody .gmf-fullbody-avatar-customizable {
  top: unset;
  left: unset;
  bottom: 10px;
  right: 10px;
  transform: unset;
}
</style>

<script>
import state from '@/state';
import FullBodyAvatar from '@/components/FullBodyAvatar.vue';
import openPopupProfileCard from '@/components/PopupProfileCard/openPopupProfileCard';

export default {
  components: {
    FullBodyAvatar,
  },
  name: 'MyAvatarFullbody',
  data () {
    return {
      state,
    };
  },
  computed: {
    profile() {
      return this.state.profile;
    }
  },
  methods: {
    openPopupProfileCard,
  }
};
</script>
